export { resolveRuntimeLikePath } from "../utils/path-resolver.js";
